export default __webpack_public_path__ + "static/media/bg6.6acb2360.jpg";